module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?> <svg width=640px height=640px viewBox=\"0 0 640 640\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink> <path d=\"M288.5,288.5 L194,288.5 L194,352.5 L288.5,352.5 L288.5,447 L352.5,447 L352.5,352.5 L447,352.5 L447,288.5 L352.5,288.5 L352.5,194 L288.5,194 L288.5,288.5 Z M320,640 C143.26888,640 0,496.73112 0,320 C0,143.26888 143.26888,0 320,0 C496.73112,0 640,143.26888 640,320 C640,496.73112 496.73112,640 320,640 Z\"></path> </svg>";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/plus-in-filled-circle.svg
// module id = 277
// module chunks = 0